import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
import api from 'core/util/api';
import { action, observable, runInAction } from 'mobx';
var DeviceSyslogsStatusStore = (_dec = observable.ref, _dec2 = observable.ref, _class = /*#__PURE__*/_createClass(function DeviceSyslogsStatusStore() {
  _classCallCheck(this, DeviceSyslogsStatusStore);
  _initializerDefineProperty(this, "fetched", _descriptor, this);
  _initializerDefineProperty(this, "lastFetched", _descriptor2, this);
  _initializerDefineProperty(this, "fetchPromise", _descriptor3, this);
  _initializerDefineProperty(this, "getDeviceSyslogsStatus", _descriptor4, this);
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "fetched", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "lastFetched", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "fetchPromise", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "getDeviceSyslogsStatus", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this = this;
    return function () {
      if (!_this.fetchPromise) {
        _this.fetchPromise = api.get('/api/ui/devices/syslog/query').then(function (results) {
          runInAction(function () {
            _this.fetched = true;
            _this.lastFetched = results;
          });
          return results;
        });
      }
      return _this.fetchPromise;
    };
  }
}), _class);
export var DeviceSyslogsStatus = new DeviceSyslogsStatusStore();